export default "__VITE_ASSET__BRglZxS$__"